import React, {useState} from "react";
import { MdArrowForwardIos, MdCheckCircle } from "react-icons/md";
import "../styles.css";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { checkIfUserUpdatedAnyDoc } from "../../utils/updatedByUser";
import { checkRequiredItemsStatus } from "../handler";
import TaxiCompanyComponent from './taxiCompany' 
import pending from '../../img/pending.svg'
import rejected from '../../img/rejected.svg'

const List = (props) => {
  const [showTaxiCompany , setShowTaxiCompany] = useState(false)

  const handleDocumentSelecion = (selectedIndex) => {
    props.setSelectedItemIndex(selectedIndex);
    if (props.memberRequirement.requiredDocuments[selectedIndex].item === "taxiCompany") {
      setShowTaxiCompany(() => true)
    } else {
      props.setOpenUploadDocument({
        openDocument: true,
        documentType:
          props.memberRequirement.requiredDocuments[selectedIndex].item,
      });
    }
  };

  // const displayDocumentStatusMessage = () => {
  //   if (props.documentStatus === 1 && !checkIfUserUpdatedAnyDoc()) {
  //     return true 
  //   } else if (props.documentStatus === 4 && !checkIfUserUpdatedAnyDoc()) {
  //     return true
  //   } else {
  //     return false
  //   }
  // }
  

  return (
    <>
      <div
        className="mt-5 m-auto w-full max-w-md p-4 bg-white rounded-lg sm:p-0 sm:mt-10 dark:bg-gray-800 dark:border-gray-700"
        style={{ paddingTop: "64px" }}
      >
        <div className="mb-4">
          <h1 className="text-2xl mb-4 font-bold leading-none text-gray-900 dark:text-white">
            Required Documents
          </h1>
          <h6><b>{props.selectedProfile.profileName}</b></h6>
          {(props.documentStatus === 1 || props.documentStatus === 4) && !checkIfUserUpdatedAnyDoc() && (
            <div className="submited-for-review-msg">
              <h1 style={{ color: "#EA9453" }}>
                <b>Review in progress</b>
              </h1>
              <span>
                Your application is under review. The verification process
                typically takes 24 hours upon submission of all requested
                documents. Any invalid submissions will be rejected. You will
                get a sms on the status of your account. If you haven't heard
                back from us after 24hrs, please click{" "}
                <span style={{ color: "#dd64a5" }}>
                  <a
                    href="https://help.rydesharing.com/hc/en-us/requests/new?ticket_form_id=12906432721689"
                    target="_black"
                    rel="noreferrer"
                  >
                    <u>here</u>
                  </a>
                </span>{" "}
                to reach us. Thank you for the patience.
              </span>
            </div>
          )}
          {props.documentStatus === 3 && !checkIfUserUpdatedAnyDoc() && (
            <div className="document-rejected-msg">
              <h1 style={{ color: "#FF2E2E" }}>
                <b>Review failed</b>
              </h1>
              <span>
                Your application has been rejected. To find out the reason for
                rejection, please refer to the SMS received to your registered
                mobile number and resubmit all relevant documents for our
                processing again. Thank you for the support.
              </span>
            </div>
          )}
          <p className="mt-1  text-gray-600">
            {/* Below are the required document to setup driver account. */}
            Below are the required document to setup account.
          </p>
        </div>
        {props.validation && (
          <>
            <div className="error-msg">
              <span>{props.errorMessage}</span>
            </div>
          </>
        )}

        <div className="flow-root doc-list">
          <ul role="list" className="divide-y divide-gray-200 dark:divide-gray-700">
            {props.memberRequirement &&
              props.memberRequirement.requiredDocuments.map((d, i) => {
                
                let requiredItemStatus = checkRequiredItemsStatus(d, props.documentStatus);
                return (
                  <>
                    <div onClick={() => handleDocumentSelecion(i)}>
                      <li className="py-3 sm:py-4 hover:shadow-md">
                        <div className="flex items-center space-x-4">
                          {
                          (requiredItemStatus === "rejectedDocuments" ) ? (
                            <div
                              className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"
                              style={{ paddingRight: "10px" }}
                            >
                              {/* <HiOutlineExclamationCircle/> */}
                            
                              <img src={rejected} alt="Ryde" />
                            </div>
                          ) : requiredItemStatus === "pendingDocumentApproval" ? (
                            <div
                              className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"
                              style={{ paddingRight: "10px" }}
                            >
                              <img src={pending} alt="Ryde" />
                              
                            </div>
                          ) : requiredItemStatus === "userUploadedDocuments" ||
                            requiredItemStatus ===
                              "updatedRejectedDocuments" ? (
                            <div
                              className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"
                              
                            >
                              <MdCheckCircle
                                style={{ color: "#15BE44", fontSize: "24px" }}
                              />
                            </div>
                          ) : (
                            <div className="flex-shrink-0">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_330_1230)">
                                  <path
                                    d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                                    fill="#2E3849"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_330_1230">
                                    <rect width="24" height="24" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          )}
                          <div className="flex-1 min-w-0">
                            <p className="font-medium text-gray-900 truncate dark:text-white">
                              {`${d.displayName}`}
                            </p>
                          </div>
                          <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                            {requiredItemStatus ===
                              "updatedRejectedDocuments" && (
                              <span style={{ color: "red", fontSize: "10px" }}>
                                <i>Updated</i>
                              </span>
                            )}
                            <MdArrowForwardIos style={{ color: "grey" }} />
                          </div>
                        </div>
                      </li>
                    </div>
                  </>
                );
              })}
          </ul>
        </div>
        <TaxiCompanyComponent 
          showTaxiCompany={showTaxiCompany}
          setShowTaxiCompany={setShowTaxiCompany}  
          memberRequirement={props.memberRequirement} 
          setMemberRequirement={props.setMemberRequirement} 
          selectedItemIndex={props.selectedItemIndex}
          setShowSaveButton={props.setShowSaveButton}
        />
      </div>
    </>
  );
};

export default List;
